<script>
	export let type = "text";
	export let options = [];
	export let error = false;
	export let errorText = "";
	export let defaultOption = "";
	export let disableFirstOption = false;
	export let defaultValue = "";
	export let value = "";
	export let onChange = () => {};
	export let disabled = false;
	export let name = "";
	export let style = "";
	export let classes = "";

	$: optionsSelect = options || [];
</script>

<div>
	<select
		{type}
		class={`form-select getgo select ${error ? "danger" : ""} ` + classes}
		bind:value
		on:change={onChange}
		{disabled}
		style={value === ""
			? "color: var(--fds-on-surface-variant) "
			: " " + style}
	>
		{#if defaultOption}
			<option
				value={defaultValue || ""}
				disabled={disableFirstOption}
				selected>{defaultOption}</option
			>
		{/if}

		{#each optionsSelect as option}
			<option value={option.id || option.value}
				>{option.name || option.label}</option
			>
		{/each}
	</select>
	{#if error}
		<small class="error-text">{errorText}</small>
	{/if}
</div>
